<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="invoice"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="所属学员" prop="student_id">
        <v-select-student class="w100" v-model="invoice.student_id" @change="handleStudentChange"/>
      </el-form-item>

      <el-form-item label="发票类型">
        <el-radio v-model="invoice.is_other" :label="0">课卡</el-radio>
        <el-radio v-model="invoice.is_other" :label="1">其他</el-radio>
      </el-form-item>

      <el-form-item v-if="invoice.is_other" label="类型名称" prop="other_name">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.other_name"
          maxlength="32"
          placeholder="请输入类型名称，例如：场地费"
          show-word-limit clearable
        />
      </el-form-item>

      <el-form-item v-else label="开票课卡" prop="card_id">
        <v-select-card-list
          class="w100"
          :student-id="invoice.student_id"
          :is-without-invoice="true"
          :is-actual-payment-positive="true"
          v-model="invoice.card_id"
          @listLengthChange="e => isCardListEmpty = !e"
          @change="handleCardChange"
        />
        <el-alert
          v-if="isCardListEmpty"
          title="学员名下暂无可开票的课卡"
          type="error"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <el-form-item label="开票金额" prop="amount">
        <v-input-money
          class="w100"
          v-model="invoice.amount"
          placeholder="选择课卡后自动匹配"
          :max="invoice.is_other ? undefined : maxAmount"
          :is-show-suffix="true"
          @input="handleAmountChange"
        />
      </el-form-item>

      <el-form-item label="发票对象">
        <el-radio v-model="invoice.is_personal" :label="0">公司</el-radio>
        <el-radio v-model="invoice.is_personal" :label="1">个人</el-radio>
      </el-form-item>

      <el-form-item label="名称" prop="invoice_name">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.invoice_name"
          maxlength="32"
          placeholder="请输入名称"
          show-word-limit clearable
        />
      </el-form-item>

      <el-form-item v-if="!invoice.is_personal" label="纳税人识别号" prop="taxpayer_id">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.taxpayer_id"
          maxlength="18"
          placeholder="请输入纳税人识别号"
          show-word-limit
          clearable
        />
      </el-form-item>

      <el-form-item label="地址、电话">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.address"
          maxlength="144"
          placeholder="请输入地址、电话"
          show-word-limit
          clearable
        />
      </el-form-item>

      <el-form-item v-if="!invoice.is_personal" label="开户行及账号">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.bank_account"
          maxlength="144"
          placeholder="请输入开户行及账号"
          show-word-limit
          clearable
        />
      </el-form-item>

      <el-form-item label="发票类目" prop="invoice_class_id">
        <v-select-invoice-class
          class="w100"
          v-model="invoice.invoice_class_id"
          @change="handleTaxRateChange"
        />
      </el-form-item>

      <el-form-item label="税额">
        {{ invoice.amount }}×{{ invoice.tax_rate }}%={{ invoice.tax_amount }}
      </el-form-item>

      <el-form-item label="开票方式">
        <el-radio v-model="invoice.is_paper" :label="0">电子发票</el-radio>
        <el-radio v-model="invoice.is_paper" :label="1">纸质发票</el-radio>
      </el-form-item>

      <template v-if="invoice.is_paper">
        <el-form-item label="收件人" prop="paper_name">
          <el-input
            class="clearable-word-limit-input"
            v-model="invoice.paper_name"
            maxlength="21"
            placeholder="请输入收件人"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item label="收件地址" prop="paper_address">
          <el-input
            class="clearable-word-limit-input"
            v-model="invoice.paper_address"
            maxlength="144"
            placeholder="请输入收件地址"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item label="收件人电话" prop="phone">
          <el-input
            class="clearable-word-limit-input"
            v-model="invoice.phone"
            maxlength="11"
            placeholder="请输入收件人电话"
            show-word-limit
            clearable
          />
        </el-form-item>
      </template>

      <el-form-item v-else label="电子邮箱" prop="email">
        <el-input
          class="clearable-word-limit-input"
          v-model="invoice.email"
          maxlength="144"
          placeholder="请输入电子邮箱地址"
          show-word-limit
          clearable
          type="email"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即申请</el-button>
        <el-button @click="RouteConfig.invoiceList.back">取消</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/invoice';
import { toCent, toYuan, multipliedBy } from "@/filters";

export default {
  name: RouteConfig.invoiceAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    isCardListEmpty: false,
    invoice: {
      student_id: 0,
      is_other: 0,
      other_name: '场地费',
      card_id: 0,
      amount: 0,
      is_personal: 0,
      invoice_name: '',
      taxpayer_id: '',
      address: '',
      bank_account: '',
      invoice_class_id: 0,
      tax_rate: 0,
      tax_amount: 0,
      is_paper: 0,
      paper_name: '',
      paper_address: '',
      phone: '',
      email: '',
    },
    maxAmount: 0,
    studentName: '',
    phone: '',
    rules: {
      student_id: [{required: true, message: '请选择所属学员', trigger: 'change'}],
      card_id: [{required: true, message: '请选择课卡', trigger: 'change'}],
      other_name: [{required: true, message: '请输入类型名称', trigger: 'change'}],
      amount: [{required: true, message: '请选择实际付款大于0的课卡', trigger: 'change'}],
      invoice_name: [{required: true, message: '请输入名称', trigger: 'change'}],
      taxpayer_id: [{required: true, message: '请输入纳税人识别号', trigger: 'change'}],
      invoice_class_id: [{required: true, message: '请选择发票类目', trigger: 'change'}],
      email: [{required: true, message: '请输入电子邮箱地址', trigger: 'change'}],
      paper_name: [{required: true, message: '请输入收件人', trigger: 'change'}],
      paper_address: [{required: true, message: '请输入收件地址', trigger: 'change'}],
      phone: [{required: true, message: '请输入收件人电话', trigger: 'change'}],
    },
  }),
  watch: {
      'invoice.is_personal'(is_personal) {
        this.invoice.invoice_name = is_personal ? this.studentName : '';
        this.invoice.address = is_personal ? `${this.phone}` : '';
      },
      'invoice.is_paper'(is_paper) {
        this.invoice.paper_name = is_paper ? this.studentName : '';
        this.invoice.phone = is_paper ? this.phone : '';
      },
  },
  methods: {
    handleStudentChange(student) {
      this.studentName = student.student_name || '';
      this.phone = student.phone || '';
      const { invoice } = this;
      Object.assign(invoice, {
        card_id: 0,
        invoice_name: invoice.is_personal ? this.studentName : '',
        address: invoice.is_personal ? `${this.phone}` : '',
        paper_name: invoice.is_paper ? this.studentName : '',
        phone: invoice.is_paper ? this.phone : '',
      });
    },
    handleCardChange({ actual_payment }) {
      const { invoice } = this;
      invoice.amount = toYuan(actual_payment);
      invoice.tax_amount = toYuan(multipliedBy(invoice.amount, invoice.tax_rate));
      this.maxAmount = invoice.amount;
    },
    handleTaxRateChange(tax_rate) {
      const { invoice } = this;
      invoice.tax_rate = toYuan(tax_rate);
      invoice.tax_amount = toYuan(multipliedBy(invoice.amount, invoice.tax_rate));
    },
    handleAmountChange(amount) {
      const { invoice } = this;
      invoice.tax_amount = toYuan(multipliedBy(amount, invoice.tax_rate));
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;

        const postData = { ...this.invoice };
        if (postData.taxpayer_id.includes(' ')) return this.$message.error('纳税人识别号不能包含空格');
        postData.amount = toCent(postData.amount);
        postData.tax_rate = toCent(postData.tax_rate);
        postData.tax_amount = toCent(postData.tax_amount);
        if (postData.is_other) postData.card_id = 0;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.invoiceList.push();
      });
    },
  },
};
</script>
